import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { RoleCode } from '../models';
import { AuthService } from '../services/auth.service';

/** Gate a route by role(s) declared in its `data.roles` array. */
@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const requiredRoles = (route.data['roles'] as RoleCode[] | undefined) ?? [];
    if (requiredRoles.length === 0 || this.authService.hasAnyRole(requiredRoles)) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
